import * as Api from '@ViewModels';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { HIPAATermsAcknowledgement } from './index';

export const HIPAATermsAcknowledgementProvider = observer(({ children }: { children: React.ReactNode }) => {
	const userSession = useUserSession();
	const [isModalDismissed, setIsModalDismissed] = useState(false);

	const hipaaAction = userSession?.pendingAccountActions?.find(
		action =>
			action.type === Api.AccountActionType.AcknowledgeHIPAATerms && action.status === Api.AccountActionStatus.Pending
	);

	// Don't show the modal during user setup flow
	const userSetupPaths = ['/user/add', '/user/accept-invite', '/user/connect-email', '/user/connect-email-success'];
	const isUserSetupFlow = userSetupPaths.some(path => window.location.hash.includes(path));
	const shouldShowModal = hipaaAction && !isModalDismissed && !isUserSetupFlow;

	return (
		<>
			{children}
			{shouldShowModal && (
				<HIPAATermsAcknowledgement pendingActionId={hipaaAction.id} onComplete={() => setIsModalDismissed(true)} />
			)}
		</>
	);
});
